import React, { useEffect, useState } from 'react';
import moment from 'moment';

import LoadingIndicator from '../../../../../../components/LoadingIndicator';
import CollapseCard from '../../../../components/CollapseCard';
import Icon from '../../../../../../components/Icon';
import {
  NF_STATUS,
  NF_STATUS_TRANSCRIPT,
} from '../../../../../../enums/nf-status';
import {
  deliveryStatus,
  deliveryStatusTranskey,
  deliveryStatusColor,
} from '../../enums';

import {
  InfoContainer,
  ContainerHeader,
  ContentContainer,
  ItemName,
  ItemValue,
  InfoWrapper,
  BorderContainer,
  CteTitleWrapper,
  CteQuantity,
  CteNumber,
  NfStatusContainer,
  StatusContainer,
  DeliveryStatusWrapper,
  StatusLight,
  Row,
  Col,
} from './styles';

const DeliveryPointInfo = ({
  isFetching,
  deliveryPointData,
  isDelivered,
  onDismiss,
}) => {
  const [tooltipHeightOffset, setTooltipHeightOffset] = useState('0px');
  const [collapseOpen, setCollapseOpen] = useState(false);

  const _calculateTooltipTopOffset = oldValue => {
    const tooltipEl = document.getElementsByClassName(
      'DeliveryPointTooltip',
    )[0];
    const tooltipHeight = tooltipEl ? tooltipEl.clientHeight : 0;
    const tooltipOffset = `-${tooltipHeight + 55}px`;
    if (oldValue !== tooltipOffset) {
      setTooltipHeightOffset(tooltipOffset);
    }
  };

  useEffect(() => {
    _calculateTooltipTopOffset(tooltipHeightOffset);
  });

  const checkGeneralStatus = invoices => {
    const invoicesStatusArray = invoices.map(el => el.status);

    if (
      invoicesStatusArray.includes(true) &&
      invoicesStatusArray.includes(false)
    ) {
      return {
        status: NF_STATUS.PARTIAL,
        message: NF_STATUS_TRANSCRIPT[NF_STATUS.PARTIAL],
      };
    }

    if (invoicesStatusArray.includes(true)) {
      return {
        status: NF_STATUS.DOWNLOADED,
        message: NF_STATUS_TRANSCRIPT[NF_STATUS.DOWNLOADED],
      };
    }

    return {
      status: NF_STATUS.REFUSED,
      message: NF_STATUS_TRANSCRIPT[NF_STATUS.DENIED],
    };
  };

  const _checkDeliveryTime = (
    transitDate,
    expectedDate,
    contractDate,
    finishedDate,
  ) => {
    const currentDayTime = moment();
    const currentDay = moment().format('YYYY-MM-DD');
    const transitDateOrContractDateDay = moment(
      contractDate || transitDate,
    ).format('YYYY-MM-DD');

    // regra 5
    if (finishedDate) {
      if (moment(finishedDate).isAfter(contractDate || transitDate)) {
        return deliveryStatus.DELAY;
      }

      // regra 6
      if (moment(finishedDate).isBefore(contractDate || transitDate)) {
        return deliveryStatus.ON_TIME;
      }
    }

    // se o horário atual for o mesmo dia da contratado
    // regra 3
    if (moment(currentDay).isSame(transitDateOrContractDateDay)) {
      if (
        moment(expectedDate).isSameOrBefore(
          moment(contractDate || transitDate).add(12, 'hours'),
        )
      ) {
        return deliveryStatus.ON_TIME;
      }
      // regra 4
      if (
        moment(expectedDate).isAfter(
          moment(contractDate || transitDate).add(12, 'hours'),
        )
      ) {
        return deliveryStatus.RISK_OF_DELAY;
      }
    }

    // regra 1
    if (moment(contractDate || transitDate).isBefore(currentDayTime)) {
      return deliveryStatus.DELAY;
    }

    // regra 2
    if (moment(contractDate || transitDate).isAfter(currentDayTime)) {
      return deliveryStatus.ON_TIME;
    }
  };

  const _returnCTEInfo = () =>
    deliveryPointData &&
    deliveryPointData.map((pd, index) => {
      const deliveryTimeStatus = _checkDeliveryTime(
        pd.transitDate,
        pd.expectedDate,
        pd.contractDate,
        pd.finishedDate,
      );

      return (
        <React.Fragment key={`CTE-${pd.cte}-${index}`}>
          <Row>
            <Col>
              <CteTitleWrapper>
                <CteNumber
                  onClick={() =>
                    setCollapseOpen(
                      collapseOpen === `CTE-${pd.cte}`
                        ? false
                        : `CTE-${pd.cte}`,
                    )
                  }
                >
                  <span>{`CTE-${pd.cte}`}</span>
                  <Icon
                    name={
                      collapseOpen === `CTE-${pd.cte}`
                        ? 'expand_less'
                        : 'expand_more'
                    }
                  />
                </CteNumber>
                {pd.finishedDate ? (
                  <StatusContainer
                    partial={
                      checkGeneralStatus(pd.invoices).status ===
                      NF_STATUS.PARTIAL
                    }
                    nfStatus={
                      checkGeneralStatus(pd.invoices).status ===
                      NF_STATUS.DOWNLOADED
                    }
                  >
                    {checkGeneralStatus(pd.invoices).message}
                  </StatusContainer>
                ) : null}
              </CteTitleWrapper>
            </Col>
          </Row>
          <CollapseCard isOpen={collapseOpen === `CTE-${pd.cte}`}>
            <Row>
              <Col md6>
                <BorderContainer>
                  <InfoWrapper>
                    <ItemName>Remetente</ItemName>
                    <ItemValue>{pd.origin.name}</ItemValue>
                  </InfoWrapper>
                  <InfoWrapper lastItem>
                    <ItemName>CNPJ</ItemName>
                    <ItemValue>{pd.origin.cnpj}</ItemValue>
                  </InfoWrapper>
                </BorderContainer>
                <BorderContainer borderless="true">
                  <InfoWrapper>
                    <ItemName>Prazo contratado</ItemName>
                    <ItemValue>
                      {moment(pd.transitDate).format('DD/MM/YYYY')}
                    </ItemValue>
                  </InfoWrapper>
                  {pd.contractDate ? (
                    <InfoWrapper>
                      <ItemName>Agendamento</ItemName>
                      <ItemValue>
                        {moment(pd.contractDate).format('DD/MM/YYYY')}
                      </ItemValue>
                    </InfoWrapper>
                  ) : null}
                  {
                    <InfoWrapper>
                      <DeliveryStatusWrapper>
                        <StatusLight
                          statusColor={deliveryStatusColor[deliveryTimeStatus]}
                        />
                        <ItemValue
                          statusColor={deliveryStatusColor[deliveryTimeStatus]}
                        >
                          {deliveryStatusTranskey[deliveryTimeStatus]}
                        </ItemValue>
                      </DeliveryStatusWrapper>
                    </InfoWrapper>
                  }
                </BorderContainer>
              </Col>
              <Col md6>
                <InfoWrapper>
                  <ItemName>
                    {`Notas Fiscais (${
                      pd && pd.invoices && pd.invoices.length
                    })`}
                  </ItemName>
                </InfoWrapper>
                <InfoWrapper>
                  {pd.invoices.map((nf, index) => (
                    <NfStatusContainer
                      key={`${nf.nfNumber}-${index}`}
                      nfStatus={nf.status}
                      lastItem={index === pd.invoices.length - 1}
                    >
                      <span>{`NF ${nf.id}`}</span>
                      {pd.finishedDate ? (
                        <StatusContainer nfStatus={nf.status}>
                          {
                            NF_STATUS_TRANSCRIPT[
                              nf.status
                                ? NF_STATUS.DOWNLOADED
                                : NF_STATUS.DENIED
                            ]
                          }
                        </StatusContainer>
                      ) : (
                        <Icon name="truck" />
                      )}
                    </NfStatusContainer>
                  ))}
                </InfoWrapper>
              </Col>
            </Row>
          </CollapseCard>
        </React.Fragment>
      );
    });

  return (
    <div>
      {deliveryPointData && (
        <InfoContainer
          className="DeliveryPointTooltip"
          style={{ top: tooltipHeightOffset }}
        >
          <ContainerHeader>
            <Icon
              className="TrackingDetails__close-modal-mobile"
              name="close"
              onClick={onDismiss}
            />
            <h2>Documentos do local de entrega</h2>
            <p>{`CTEs (${deliveryPointData.length})`}</p>
          </ContainerHeader>
          {/* =====================
        Loading State
        ========================= */}

          {isFetching && (
            <div className="DeliveryStatus__LoadingIndicator">
              <LoadingIndicator text="Carregando..." theme="dark" />
            </div>
          )}

          {/* =====================
        Error State
        ========================= */}

          {
            //   error &&
            //   isFetching &&
            //   <div className="DeliveryStatus__error-message">
            //     <AlertMessage
            //       error
            //       message="Ocorreu um erro"
            //       actionText="Tente novamente"
            //       onRetry={() => this._onRetry()}
            //     />
            //   </div>
            //
          }

          {/* =====================
        Normal state
        ========================= */}

          <ContentContainer>
            <Row>
              <Col md6>
                <InfoWrapper>
                  <ItemName>Destinatário</ItemName>
                  <ItemValue>{deliveryPointData[0].name}</ItemValue>
                </InfoWrapper>
                {isDelivered ? (
                  <InfoWrapper>
                    <ItemName>Entregue</ItemName>
                    <ItemValue>
                      {moment(deliveryPointData[0].finishedDate).format(
                        'DD/MM/YYYY - HH:mm',
                      )}
                    </ItemValue>
                  </InfoWrapper>
                ) : null}
              </Col>
              <Col md6>
                <BorderContainer>
                  <InfoWrapper>
                    <ItemName>Endereço</ItemName>
                    <ItemValue>{deliveryPointData[0].address}</ItemValue>
                  </InfoWrapper>
                  <InfoWrapper lastItem={!deliveryPointData[0].redelivery}>
                    <ItemName>Cidade</ItemName>
                    <ItemValue>
                      {`${deliveryPointData[0].city}-${deliveryPointData[0].state}`}
                    </ItemValue>
                  </InfoWrapper>

                  {deliveryPointData[0].redelivery ? (
                    <React.Fragment>
                      <InfoWrapper divider>
                        <ItemName>Endereço de redespacho</ItemName>
                        <ItemValue>
                          {deliveryPointData[0].redelivery.address}
                        </ItemValue>
                      </InfoWrapper>
                      <InfoWrapper lastItem>
                        <ItemName>Cidade</ItemName>
                        <ItemValue>
                          {deliveryPointData[0].redelivery.address}
                        </ItemValue>
                      </InfoWrapper>
                    </React.Fragment>
                  ) : null}
                </BorderContainer>
              </Col>
            </Row>
            <Row>
              <Col>
                <CteQuantity>
                  <span>{`Notas Fiscais (${deliveryPointData.length})`}</span>
                </CteQuantity>
              </Col>
            </Row>
            {_returnCTEInfo()}
          </ContentContainer>
        </InfoContainer>
      )}
    </div>
  );
};

export default DeliveryPointInfo;
